export function formatCount(n: number): string {
  if (n >= 10000) {
    const w = n / 10000;
    return `${w % 1 === 0 ? w.toFixed(0) : w.toFixed(1)}万`;
  }
  return n.toLocaleString("zh-CN");
}

export function formatNumber(n: number): string {
  return n.toLocaleString("zh-CN");
}